module.exports = __webpack_public_path__ + "static/img/8.c550464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/8.png
// module id = chwS
// module chunks = 0